<script setup>
// Manuel Sipariş (Kişiler menüsü) — konuşmadan bağımsız sipariş ekranı.
// panel-app sihirbazını standalone modda açar: kampanya (K1) + peşin %5
// indirimleri uygulanır, sipariş kaynağı İnteraktif.tech olarak işaretlenir,
// temsilci atfı (order_links) currentUser üzerinden yazılır.
//
// DİKKAT: iframe adresi computed OLAMAZ — currentUser store'da her
// güncellendiğinde (ör. çevrimiçi durum) adres yeniden üretilir ve iframe
// sıfırdan yüklenip temsilcinin yarım sepetini uçurur (13 Ağu canlı bug'ı).
// Adres bir kez kurulur, yalnız platform (rota) değişince bilerek yenilenir.
import { ref, computed, watch, watchEffect } from 'vue';
import { useRoute } from 'vue-router';
import { useMapGetter } from 'dashboard/composables/store';

const route = useRoute();
const currentUser = useMapGetter('getCurrentUser');

const platform = computed(() =>
  route.name === 'manual_order_shopify' ? 'shopify' : 'ticimax'
);

const title = computed(() =>
  platform.value === 'shopify'
    ? 'Manuel Sipariş — ModaXLarge (Shopify)'
    : 'Manuel Sipariş — Koza Butik (Ticimax)'
);

const panelUrl = ref('');

const buildUrl = () => {
  const params = new URLSearchParams({
    standalone: '1',
    platform: platform.value,
    agent_id: currentUser.value?.id || '',
    agent_name: currentUser.value?.name || '',
    v: String(Date.now()),
  });
  return `/panel-app/index.html?${params.toString()}`;
};

// İlk kurulum: currentUser hazır olur olmaz BİR KEZ üret, sonra dokunma.
watchEffect(() => {
  if (panelUrl.value) return;
  if (!currentUser.value?.id) return;
  panelUrl.value = buildUrl();
});

// Koza ↔ ModaX menü geçişi: bilinçli yeniden yükleme (sepet zaten mağazaya özel).
watch(platform, () => {
  panelUrl.value = buildUrl();
});
</script>

<template>
  <div class="flex flex-col w-full h-full min-h-0 bg-n-background">
    <div
      class="flex items-center gap-2 px-4 py-3 border-b border-n-weak text-n-slate-12"
    >
      <span class="text-base font-semibold">🛒 {{ title }}</span>
      <span class="text-sm text-n-slate-11">
        Konuşmadan bağımsız sipariş — kampanya ve peşin ödeme indirimleri
        otomatik uygulanır.
      </span>
    </div>
    <iframe
      v-if="panelUrl"
      :src="panelUrl"
      class="flex-1 w-full border-0"
      title="Manuel Sipariş"
    />
  </div>
</template>
